<script>
import config from '../../common/genericPanelConf';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import CommonService from '../../services/common';
import Service from '../../services/operative-plan';

import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import Calendar from 'primevue/calendar';
import GenericDataTable from '../generic/GenericDataTable.vue'
import GenericCustomMasterDataAutocompleteV2 from '../generic/GenericCustomMasterDataAutocompleteV2.vue'
import ResponsiveButton from '../generic/ResponsiveButton.vue'
import EquipmentDialog from './EquipmentDialog.vue';

export default {
    emit: ['showSchedulingAttachmentsDialog'],
    setup: () => ({ v$: useVuelidate() }),
    components: {
        Calendar, GenericCustomMasterDataAutocompleteV2, ResponsiveButton,
        GenericDataTable,
        EquipmentDialog
    },
    created(){
        this.originalConf = config.getConfiguration('OperativePlanScheduled');
        this.configuration = { ...this.originalConf};
    },
    mounted(){
        this.loadFromCache();
    },
    data(){
        return{
            originalConf: {},
            submitted: false,
            configuration: {},
            filters: {
                dateTo: Utils.formatDatePlusMonths(new Date(), 1),
                plantId: CommonConstants.defaultPlantId
            },
            equipmentDialog: {
                visible: false,
                record: null
            },
            platformDialog: {
                visible: false,
                record: null
            },
            showHidden: false
        }
    },
     watch: {
        'filters.plantId'(newValue){
            this.$emit('onPlantChanged', newValue);
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },
    validations(){
        return {
            filters: {
                dateTo: {required},
                plantId: {}
            }
        }
    },
    methods: {
        load(valid){
            this.submitted = true;
            if(valid){
                let filters = {
                    dateTo: Utils.formatDateForAPI(this.filters.dateTo),
                    plantId: this.filters.plantId
                }
                this.saveCache();
                this.$refs.operativePlanGrid.filterFromView(filters, true);
            }
        },
        performDialogEditSave(item, originalItem){
            let upd = false;
            let toUpdate = {
                id: item.id
            };

            if(item.scheduledOperationDate != originalItem.scheduledOperationDate){
                upd = true;
                toUpdate.scheduledOperationDate = item.scheduledOperationDate
                toUpdate.scheduledOperationDateUpdated = true;
            }

            if(item.etaDate != originalItem.etaDate){
                upd = true;
                toUpdate.etaDate = item.etaDate
                toUpdate.etaDateUpdated = true;
            }

            if(item.mooringDate != originalItem.mooringDate){
                upd = true;
                toUpdate.mooringDate = item.mooringDate
                toUpdate.mooringDateUpdated = true;
            }

            if(item.unmooringDate != originalItem.unmooringDate){
                upd = true;
                toUpdate.unmooringDate = item.unmooringDate
                toUpdate.unmooringDateUpdated = true;
            }

            if(item.idMooringPlatform != originalItem.idMooringPlatform){
                upd = true;
                toUpdate.idMooringPlatform = item.idMooringPlatform
                toUpdate.idMooringPlatformUpdated = true;
            }

            if(item.notes != originalItem.notes){
                upd = true;
                toUpdate.notes = item.notes
                toUpdate.notesUpdated = true;
            }

            if(item.noteScheduling != originalItem.noteScheduling){
                upd = true;              
            }

            toUpdate.noteScheduling = item.noteScheduling
            
            if(item.isHidden != originalItem.isHidden){
                upd = true;
                toUpdate.isHidden = item.isHidden
                toUpdate.isHiddenUpdated = true;
            }

            if(item.isVesselInRoadstead != originalItem.isVesselInRoadstead){
                upd = true;
                toUpdate.isVesselInRoadstead = item.isVesselInRoadstead
                toUpdate.isVesselInRoadsteadUpdated = true;
            }

            if(item.idRegistryShippingAgency != originalItem.idRegistryShippingAgency){
                upd = true;
                toUpdate.idRegistryShippingAgency = item.idRegistryShippingAgency
                toUpdate.idRegistryShippingAgencyUpdated = true;
            }

            if(upd){
                CommonService.updateItem(this.originalConf.updateApi, toUpdate, response => {
                    if(response.success){
                        this.$refs.operativePlanGrid.hideDialogEdit();
                        this.load(true);
                        if(response.message){
                            this.$toast.add({detail: response.message , life:3000, severity: 'warn'});
                        }
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }
        },
        onDialogEditSave(item, originalItem){
            let showAlert = false;
            if(item.mooringDate != null){
                showAlert = new Date(item.mooringDate) < new Date(item.laycanStartDate);

                if(item.unmooringDate != null){
                    if(new Date(item.mooringDate) > new Date(item.unmooringDate)){
                        this.$toast.add({detail: this.$t('operativePlan.errorMooringDateAfterUnmooringDate'), life:3000, severity:'error'});
                        return;
                    }
                }
            }
            if(showAlert){
                this.$confirm.require({
                    message: this.$t('operativePlan.alertMooringDateBeforeLaycanStart'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {
                        this.performDialogEditSave(item, originalItem);
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                        this.$confirm.close();
                    }
                });
            }else{
                this.performDialogEditSave(item, originalItem);
            }
           

        },
        onCellEditComplete(event){
            let originalData = event.data;
            let newData = event.newData;

            let oldValue = originalData[event.field];
            let newValue = newData[event.field];
            let upd = oldValue != newValue;

            let fieldName = event.field;
            let fieldNameUpd = event.field + 'Updated';

            switch(event.field){
                case 'etaDate':
                case 'laycanStartDate':
                case 'laycanEndDate':
                case 'mooringDate':
                case 'unmooringDate':
                case  'scheduledOperationDate':
                    if(originalData[event.field] != null){
                        oldValue = new Date(Utils.dateToCurrentTimeZone(originalData[event.field]));
                    }
                    upd = !Utils.dateEquals(oldValue, newValue);
                break;
                case 'mooringPlatform':
                    newValue = newData['idMooringPlatform'];
                    upd = oldValue != newValue;

                    fieldName = 'idMooringPlatform';
                    fieldNameUpd = 'idMooringPlatformUpdated';
                    break;
                case 'idRegistryShippingAgency':
                    newValue = newData['idRegistryShippingAgency'];
                    upd = oldValue != newValue;

                    fieldName = 'idRegistryShippingAgency';
                    fieldNameUpd = 'idRegistryShippingAgencyUpdated';
                    break;
            }
            if(upd){
                let toUpdate = {
                    id: newData.id,
                };
                toUpdate[fieldName] = newData[fieldName];
                toUpdate[fieldNameUpd] = true;
                
                this.$store.dispatch("generic/setLoading", true);
                CommonService.updateItem(this.originalConf.updateApi, toUpdate, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.load(true);
                        if(response.message){
                            this.$toast.add({detail: response.message , life:3000, severity: 'warn'});
                        }
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }
        },
        showEquipmentDialog(record){
            this.equipmentDialog = {
                visible: true,
                idRegistryPlant: record.idRegistryPlant
            };
            this.$refs.equipmentDialog.loadEquipmentLayout(record.id, false, record.equipmentOperationTank);
            this.$refs.equipmentDialog.show();
        },
        printPdf(){
            let params = {
                dateTo: Utils.formatDateForAPI(this.filters.dateTo),
                plantId: this.filters.plantId
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.printScheduledSheet(params, response => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'ScheduledSheet.pdf');
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        setPlant(plantId){
            this.filters.plantId = plantId;
        },
        plantChange(e){
            this.$emit('onPlantChanged', e.value);
        },
        loadFromCache(){
            let cacheData = this.$store.getters['cacheDataStore/getGridCache']('ScheduledSheetGrid');
            if(cacheData){
                this.filters.dateTo = cacheData.dateTo,
                this.filters.plantId = cacheData.plantId
            }
            
            this.load(true);
        },
        saveCache(){
            let cacheData = {
                name: 'ScheduledSheetGrid',
                filters: {
                    plantId: this.filters.plantId,
                    dateTo: this.filters.dateTo
                }
            };
            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
        },
        showSchedulingAttachmentsDialog(record){
            this.$emit('showSchedulingAttachmentsDialog', record)
        }
    },
}
</script>

<template>
    <main>
        <EquipmentDialog ref="equipmentDialog" :item="equipmentDialog" :refreshGrid="load"/>
        <div class="grid">
            <div class="col-12 lg:col-2 field mt-3 mx-3">
                <label for="from" :class="{'p-error':v$.filters.dateTo.$invalid && submitted}">{{$t('operativePlan.mooringsDateTo')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dateTo.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dateTo"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dateTo.$invalid && submitted) || v$.filters.dateTo.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dateTo.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field mt-3 mx-3">
                <label for="plant" :class="{'p-error':v$.filters.plantId.$invalid && submitted}">{{$t('registryPlant.fk')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    field="label"
                        :name="'registry-plant'"
                    v-model="filters.plantId"
                    api="masterdata/registry-plant-combo"
                    :addEmpty="true"
                    :emptyValue="null"
                    :emptyLabel="$t('all')"
                    :format="{ label: 'description', value: 'id' }"
                    :class="{'p-invalid':v$.filters.plantId.$invalid && submitted, 'p-inputtext-sm w-full': true}" />
                <div v-if="(v$.filters.plantId.$invalid && submitted) || v$.filters.plantId.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.plantId.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <!-- <div class="col-12 lg:col-1 field">
                <label >{{$t('showHidden')}}</label>
                <div>
                    <TriStateCheckbox class="p-inputtext-sm" v-model="showHidden" />
                    <span class="ml-3">{{showHidden == null ? $t('all') : (showHidden ? $t('yes'): $t('no'))}}</span>
                </div>
            </div> -->
            <div class="col-12 lg:col-7 mt-6">
                <ResponsiveButton :label="$t('btn.refresh')" icon="pi pi-replay" class="p-button-sm mx-1" @click="load(!v$.$invalid)"/>
                <ResponsiveButton :label="$t('operativePlan.addMovementInstruction')" icon="pi pi-plus" class="mx-1 p-button-outlined  p-button-sm" @click="$router.push(`/movement-instruction/0`)" :disabled="!uiPermissions('movementInstructionAddButton').isEnabled"/>
                <ResponsiveButton :label="$t('btn.print')" icon="pi pi-file-pdf" class="mx-1 p-button-outlined p-button-sm" @click="printPdf"/>
            </div>
            <div class="col-12" style="height: 65vh;">
                <GenericDataTable :configuration="configuration" :category="'operative'" :name="'plan'" ref="operativePlanGrid" :onCellEditComplete="onCellEditComplete" @show-equipment-dialog="showEquipmentDialog" :onDialogEditSave="onDialogEditSave" @showSchedulingAttachmentsDialog="showSchedulingAttachmentsDialog" />
            </div>
        </div>
    </main>
</template>